import { createBrowserRouter, Outlet } from "react-router";
import { Anmelden } from "./seiten/Anmelden";
import { AnmeldenToken } from "./seiten/AnmeldenToken";
import { Geschuetzt, Start } from "./seiten/Start";
import { ZweiterFaktor } from "./seiten/ZweiterFaktor";
import { Konto } from "./seiten/Konto";
import { Platzhalter } from "./seiten/Platzhalter";
import { LadenShell } from "./laden/LadenShell";
import { Uebersicht } from "./laden/Uebersicht";
import { Einstellungen } from "./laden/Einstellungen";
import { EinstellungenKasse } from "./laden/EinstellungenKasse";
import { Protokoll } from "./laden/Protokoll";
import { Verkaeufe } from "./laden/Verkaeufe";
import { CsvImport } from "./laden/CsvImport";
import { Artikel, Personal } from "./laden/Stammdaten";
import { Regale } from "./laden/Regale";
import { RegalDetail } from "./laden/RegalDetail";
import { Belegung } from "./laden/Belegung";
import { BuchungAnlegen } from "./laden/BuchungAnlegen";
import { BuchungDetail } from "./laden/BuchungDetail";
import { Mieter } from "./laden/Mieter";
import { MieterDetail } from "./laden/MieterDetail";
import { Einrichtung } from "./laden/Einrichtung";
import { EinstellungenPreise } from "./laden/EinstellungenPreise";
import { EinstellungenRegeln } from "./laden/EinstellungenRegeln";
import { EinstellungenAbrechnung } from "./laden/EinstellungenAbrechnung";
import { LadenplanSeite } from "./laden/Ladenplan";
import { Abrechnungen as LadenAbrechnungen } from "./laden/Abrechnungen";
import { AbrechnungDetail } from "./laden/AbrechnungDetail";
import { Forderungen } from "./laden/Forderungen";
import { Kassenbuch } from "./laden/Kassenbuch";
import { MieterShell } from "./mieter/MieterShell";
import { MieterStart } from "./mieter/Start";
import { MeinRegal } from "./mieter/Regal";
import { Termin } from "./mieter/Termin";
import { Abholen } from "./mieter/Abholen";
import { Inventur } from "./mieter/Inventur";
import { Aktionen } from "./mieter/Aktionen";
import { Sicherheit } from "./mieter/Sicherheit";
import { Werben } from "./mieter/Werben";
import { Sammel } from "./mieter/Sammel";
import { FeedbackSeite, Neuigkeiten as LadenNeuigkeiten, Termine as LadenTermine } from "./laden/MieterKontakt";
import { MieterVertrag } from "./mieter/Vertrag";
import { Erfassen } from "./mieter/Erfassen";
import { Kopieren } from "./mieter/Kopieren";
import { MeineArtikel } from "./mieter/MeineArtikel";
import { ArtikelDetail } from "./mieter/ArtikelDetail";
import { Etiketten } from "./mieter/Etiketten";
import { Abrechnungen, MieterAbrechnungDetail } from "./mieter/Abrechnungen";
import { Packliste } from "./mieter/Packliste";
import { Teilen } from "./mieter/Teilen";
import { Konto as MieterKonto } from "./mieter/Konto";
import { Rueckblick } from "./mieter/Rueckblick";
import { RegalSeite } from "./seiten/RegalSeite";
import { RechtlicheSeite } from "./seiten/Rechtliches";
import { Rechtliches } from "./admin/Rechtliches";
import { Sepa } from "./laden/Sepa";
import { Auswertungen } from "./laden/Auswertungen";
import { Warteliste } from "./laden/Warteliste";
import { Aufgaben } from "./laden/Aufgaben";
import { Schichtplan } from "./laden/Schichtplan";
import { WartelisteSeite } from "./seiten/WartelisteSeite";
import { Display } from "./seiten/Display";
import { RegalWeiche } from "./seiten/RegalWeiche";
import { RueckgabeKiste } from "./mieter/RueckgabeKiste";
import { Profil } from "./mieter/Profil";
import { AdminShell } from "./admin/AdminShell";
import { Laeden } from "./admin/Laeden";
import { Postfach } from "./admin/Postfach";
import { KasseApp } from "./kasse/KasseApp";
import { Tabs } from "./ui/Layout";
import { Registrieren } from "./seiten/Registrieren";
import { Abo } from "./laden/Abo";
import { Betrieb } from "./admin/Betrieb";
import { Filialen } from "./laden/Filialen";
import { Events } from "./laden/Events";
import { Import } from "./laden/Import";
import { Newsletter } from "./laden/Newsletter";
import { NeuImLaden, NewsletterBestaetigung } from "./seiten/NeuImLaden";

function EinstellungenTabs() {
  return (
    <>
      <Tabs items={[{ to: "/laden/einstellungen", label: "Laden", end: true }, { to: "/laden/einstellungen/kasse", label: "Kasse & SumUp" }, { to: "/laden/einstellungen/personal", label: "Personal & Rechte" }, { to: "/laden/einstellungen/preise", label: "Preise & Miete" }, { to: "/laden/einstellungen/regeln", label: "Regeln" }, { to: "/laden/einstellungen/abrechnung", label: "Abrechnung" }, { to: "/laden/einstellungen/abo", label: "Abo" }]} />
      <Outlet />
    </>
  );
}

export const router = createBrowserRouter([
  { path: "/", element: <Start /> },
  { path: "/anmelden", element: <Anmelden /> },
  { path: "/registrieren", element: <Registrieren /> },
  { path: "/neu/:slug", element: <NeuImLaden /> },
  { path: "/n/:slug/bestaetigen/:token", element: <NewsletterBestaetigung art="bestaetigen" /> },
  { path: "/n/:slug/abmelden/:token", element: <NewsletterBestaetigung art="abmelden" /> },
  { path: "/anmelden/code", element: <ZweiterFaktor /> },
  { path: "/r/:slug/:nummer", element: <RegalSeite /> },
  { path: "/w/:slug", element: <WartelisteSeite /> },
  { path: "/display/:code", element: <Display /> },
  { path: "/regal/:slug/:nummer", element: <RegalWeiche /> },
  { path: "/impressum", element: <RechtlicheSeite /> },
  { path: "/datenschutz", element: <RechtlicheSeite /> },
  { path: "/anmelden/:token", element: <AnmeldenToken /> },
  { path: "/kasse/*", element: <KasseApp /> },
  {
    path: "/laden",
    element: (
      <Geschuetzt bereich="laden">
        <LadenShell />
      </Geschuetzt>
    ),
    children: [
      { index: true, element: <Uebersicht /> },
      { path: "verkaeufe", element: <Verkaeufe /> },
      { path: "verkaeufe/csv-import", element: <CsvImport /> },
      { path: "regale", element: <Regale /> },
      { path: "regale/plan", element: <LadenplanSeite /> },
      { path: "regale/:id", element: <RegalDetail /> },
      { path: "belegung", element: <Belegung /> },
      { path: "buchungen/neu", element: <BuchungAnlegen /> },
      { path: "buchungen/:id", element: <BuchungDetail /> },
      { path: "mieter", element: <Mieter /> },
      { path: "mieter/:id", element: <MieterDetail /> },
      { path: "abrechnungen", element: <LadenAbrechnungen /> },
      { path: "abrechnungen/:id", element: <AbrechnungDetail /> },
      { path: "forderungen", element: <Forderungen /> },
      { path: "warteliste", element: <Warteliste /> },
      { path: "aufgaben", element: <Aufgaben /> },
      { path: "schichtplan", element: <Schichtplan /> },
      { path: "sepa", element: <Sepa /> },
      { path: "auswertungen", element: <Auswertungen /> },
      { path: "kassenbuch", element: <Kassenbuch /> },
      { path: "konto", element: <Konto /> },
      { path: "termine", element: <LadenTermine /> },
      { path: "neuigkeiten", element: <LadenNeuigkeiten /> },
      { path: "feedback", element: <FeedbackSeite /> },
      { path: "events", element: <Events /> },
      { path: "newsletter", element: <Newsletter /> },
      { path: "filialen", element: <Filialen /> },
      { path: "import", element: <Import /> },
      { path: "artikel", element: <Artikel /> },
      {
        path: "einstellungen",
        element: <EinstellungenTabs />,
        children: [
          { index: true, element: <Einstellungen /> },
          { path: "kasse", element: <EinstellungenKasse /> },
          { path: "personal", element: <Personal /> },
          { path: "preise", element: <EinstellungenPreise /> },
          { path: "regeln", element: <EinstellungenRegeln /> },
          { path: "abrechnung", element: <EinstellungenAbrechnung /> },
          { path: "abo", element: <Abo /> },
        ],
      },
      { path: "protokoll", element: <Protokoll /> },
      { path: "einrichtung", element: <Einrichtung /> },
    ],
  },
  {
    path: "/admin",
    element: (
      <Geschuetzt bereich="admin">
        <AdminShell />
      </Geschuetzt>
    ),
    children: [
      { path: "konto", element: <Konto kicker="Anbieter" /> },
      { index: true, element: <Laeden /> },
      { path: "postfach", element: <Postfach /> },
      { path: "rechtliches", element: <Rechtliches /> },
      { path: "betrieb", element: <Betrieb /> },
    ],
  },
  {
    path: "/mieter",
    element: (
      <Geschuetzt bereich="mieter">
        <MieterShell />
      </Geschuetzt>
    ),
    children: [
      { index: true, element: <MieterStart /> },
      { path: "regal", element: <MeinRegal /> },
      { path: "termin", element: <Termin /> },
      { path: "abholen", element: <Abholen /> },
      { path: "inventur", element: <Inventur /> },
      { path: "aktionen", element: <Aktionen /> },
      { path: "sicherheit", element: <Sicherheit /> },
      { path: "werben", element: <Werben /> },
      { path: "sammel", element: <Sammel /> },
      { path: "vertrag/:id", element: <MieterVertrag /> },
      { path: "erfassen", element: <Erfassen /> },
      { path: "artikel", element: <MeineArtikel /> },
      { path: "artikel/:id", element: <ArtikelDetail /> },
      { path: "artikel/:id/kopieren", element: <Kopieren /> },
      { path: "etiketten", element: <Etiketten /> },
      { path: "abrechnungen", element: <Abrechnungen /> },
      { path: "abrechnungen/:id", element: <MieterAbrechnungDetail /> },
      { path: "packliste", element: <Packliste /> },
      { path: "teilen", element: <Teilen /> },
      { path: "konto", element: <MieterKonto /> },
      { path: "rueckblick", element: <Rueckblick /> },
      { path: "rueckgabe-kiste", element: <RueckgabeKiste /> },
      { path: "profil", element: <Profil /> },
      { path: "*", element: <Platzhalter titel="Noch nicht da" etappe="Etappe 4 und 5" /> },
    ],
  },
  { path: "*", element: <Platzhalter titel="Diese Seite gibt es nicht" etappe="keiner Etappe – bitte den Link prüfen" /> },
]);
